import { Button } from '@/components/ui/button';
import { AlertCircle, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Content from '../components/layout/Content';

const Error404 = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex flex-col items-center justify-center min-h-[60vh] text-center'>
                    <div className='p-4 bg-red-100 rounded-full mb-6'>
                        <AlertCircle className='h-16 w-16 text-red-600' />
                    </div>
                    <h1 className='text-6xl font-bold text-gray-900 mb-4'>404</h1>
                    <p className='text-xl text-gray-600 mb-8'>
                        Diese Seite wurde nicht gefunden
                    </p>
                    <Button onClick={() => navigate('/')} size='lg'>
                        <Home className='mr-2 h-4 w-4' />
                        Zurück zum Start
                    </Button>
                </div>
            </div>
        </Content>
    );
};

export default Error404;
